import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { getFeatureItemBySlug } from 'src/consumer/services/featureServices'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { isTokenInvalidOrAbsent } from 'src/views/pages/login/ProtectedRoute'
import { LoadingSpinner } from '../Loaders'
import PrewallAndPaywall from '../PrewallAndPaywall/PrewallAndPaywall'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import {
  InfoAndSingleActionComponentVarOne,
  RelatedAppFeaturesComponent,
} from '../ListingPageComponentsAndHelpers/ListingPageComponents'
import FaqSection from '../PrewallAndPaywall/FaqSection'
import { FAQ_CATEGORIES, defaultBgImgId } from 'src/consumer/constants'
import { isUserAllowedToAccessContent } from '../ActivityPlansPage/activityPlanHelpers'
import { CoursePlayerIsolated } from '../CourseCards/CoursePlayer'
import { resetPlayerData } from 'src/consumer/helpers/playerHelper'
import { PublicAppFooter } from '../PublicAppFooter'
import { FAQ_LAYOUTS } from '../PrewallAndPaywall/faqComponents/utils'

export default function CourseCategoryLandingPage({ prechosenCategory }) {
  const navigate = useNavigate()
  const { courseSlug, courseId } = useParams()

  const { profileData } = useContext(ProfileContext)
  const { setupData } = useContext(SetupContext)

  const [courseData, setCourseData] = useState()
  const [dataLoading, setDataLoading] = useState(false)

  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [prewallOpen, setPrewallOpen] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')

  const [playerData, setPlayerData] = useState({
    showPIP: false,
    showLeavingEarly: false,
    showPlayer: false,
    selectedCard: '',
    showCompletionFeedback: false,
    source: '',
    id: '',
    otherData: {},
  })

  async function pageSetup() {
    setDataLoading(true)

    let response
    if (courseSlug) {
      response = await getFeatureItemBySlug('course', courseSlug, true)
    } else {
      response = await getFeatureItemBySlug('course', courseId, false)
    }
    if (response?.status === 200 && response?.data && Object.keys(response?.data)?.length !== 0) {
      setCourseData(response?.data?.data)
      setDataLoading(false)
    } else {
      navigate('/404')
    }
  }

  useEffect(() => {
    pageSetup()
  }, [])

  const handleStartLandingPage = () => {
    if (isTokenInvalidOrAbsent(localStorage.getItem('token'))) {
      setShowClubbedAuthModal(true)
    } else {
      if (allowAccessToContent) {
        setPlayerData({
          ...resetPlayerData(playerData),
          showPlayer: true,
          selectedCard: playerData.showPIP ? playerData?.selectedCard : courseData,
        })
      } else {
        setPrewallOpen(true)
      }
    }
  }

  let allowAccessToContent
  if (
    courseData?.course?.subscription?.id &&
    courseData?.course?.subscription?.id !== 'subscription_free'
  ) {
    if (localStorage.getItem('token')) {
      if (
        isUserAllowedToAccessContent(
          profileData?.subscriptionTypeId,
          courseData?.course?.subscription?.id,
        )
      ) {
        allowAccessToContent = true
      } else {
        allowAccessToContent = false
      }
    } else {
      allowAccessToContent = false
    }
  } else {
    allowAccessToContent = true
  }

  return (
    <>
      {courseData && (
        <SEOComponent
          title={`${courseData?.course?.title} | AUMHUM`}
          description={
            courseData?.course?.shortDesc?.replaceAll('"', '') ||
            courseData?.course?.longDesc?.replaceAll('"', '') ||
            `Go through this ${courseData?.course?.title} course.`
          }
          image={courseData && getImageLink(courseData?.course?.coverIcon)}
        />
      )}
      {dataLoading ? (
        <LoadingSpinner bgColor="#F5F5F599" dark />
      ) : (
        <>
          <PublicAppHeader
            loginFunction={() => {
              setTypeOfClubbedAuthModal('login')
              setShowClubbedAuthModal(true)
            }}
            registerFunction={() => {
              setTypeOfClubbedAuthModal('signup')
              setShowClubbedAuthModal(true)
            }}
            config={{ showLinks: false }}
            propUserProfileData={profileData}
          />
          <ClubbedAuthModal
            open={showClubbedAuthModal}
            onClose={() => {
              setShowClubbedAuthModal(false)
            }}
            loginVariant={typeOfClubbedAuthModal === 'login'}
          />
          <InfoAndSingleActionComponentVarOne
            headline={courseData?.course?.title}
            description={courseData?.course?.shortDesc}
            image={getImageLink(courseData?.course?.coverIcon, defaultBgImgId)}
            actionButtonText="Play"
            clickFunction={() => handleStartLandingPage()}
          />
          <RelatedAppFeaturesComponent domainsArray={[]} featuresArrayInOrder={['mentor']} />
          <FaqSection
            categoryIds={[FAQ_CATEGORIES.therapist_booking_page_faqs]}
            layoutType={FAQ_LAYOUTS.TWO_COLUMN_SIDEBAR}
          />
          {playerData?.showPlayer && (
            <CoursePlayerIsolated playerData={playerData} setPlayerData={setPlayerData} />
          )}
          <PrewallAndPaywall
            id="journal_play"
            secureData={setupData}
            wallIsOpen={prewallOpen}
            toggleWall={() => {
              setPrewallOpen((prev) => !prev)
            }}
          />
          <PublicAppFooter />
        </>
      )}
    </>
  )
}

///////////////
